var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.countdownTime ? _c('div', {
    class: _vm.$style.mileContainer,
    on: {
      "click": _vm.openCvent
    }
  }, [_c('div', {
    staticClass: "w-100 h-100"
  }, [_vm.addLeftFade ? _c('div', {
    class: _vm.$style.leftFade
  }) : _vm._e(), _c('VueCountdown', {
    ref: "mileCountdown",
    attrs: {
      "emit-events": "",
      "time": _vm.countdownTime
    },
    on: {
      "progress": _vm.updateCountdown,
      "start": function start() {
        _vm.timerStarted = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm.timerStarted ? _c('div', {
          class: _vm.$style.circlesContainer,
          style: {
            'margin-top': _vm.measureToHeightRatio(27) + 'px',
            'margin-left': -_vm.measureToHeightRatio(-6) + 'px'
          }
        }, [_c('div', {
          staticClass: "position-relative",
          style: {
            width: _vm.measureToHeightRatio(270) + 'px',
            height: _vm.measureToHeightRatio(270) + 'px'
          }
        }, [_c('SvgTimerCircle', {
          attrs: {
            "base-height": _vm.height,
            "desired-height": 270,
            "progress": _vm.daysProgress || Math.ceil(100 * props.days / 109)
          }
        }), _c('p', {
          class: _vm.$style.circleText,
          style: {
            height: _vm.measureToHeightRatio(270) + 'px',
            'font-size': _vm.height / 4 + 'px'
          }
        }, [_vm._v(_vm._s(props.days))]), _c('p', {
          class: _vm.$style.circleLabel,
          style: {
            'margin-top': -(_vm.height / 66.666) + 'px',
            'font-size': _vm.height / 11.111 + 'px'
          }
        }, [_vm._v("DAYS")])], 1), _c('div', {
          staticClass: "position-relative",
          style: {
            width: _vm.measureToHeightRatio(270) + 'px',
            height: _vm.measureToHeightRatio(270) + 'px',
            'margin-right': -_vm.measureToHeightRatio(20) + 'px',
            'margin-left': -_vm.measureToHeightRatio(20) + 'px'
          }
        }, [_c('SvgTimerCircle', {
          attrs: {
            "base-height": _vm.height,
            "desired-height": 270,
            "progress": _vm.hoursProgress || Math.ceil(100 * props.hours / 24)
          }
        }), _c('p', {
          class: _vm.$style.circleText,
          style: {
            height: _vm.measureToHeightRatio(270) + 'px',
            'font-size': _vm.height / 4 + 'px'
          }
        }, [_vm._v(_vm._s(props.hours))]), _c('p', {
          class: _vm.$style.circleLabel,
          style: {
            'margin-top': -(_vm.height / 66.666) + 'px',
            'font-size': _vm.height / 11.111 + 'px'
          }
        }, [_vm._v("HOURS")])], 1), _c('div', {
          staticClass: "position-relative",
          style: {
            width: _vm.measureToHeightRatio(270) + 'px',
            height: _vm.measureToHeightRatio(270) + 'px'
          }
        }, [_c('SvgTimerCircle', {
          attrs: {
            "base-height": _vm.height,
            "desired-height": 270,
            "progress": _vm.minutesProgress || Math.ceil(100 * props.minutes / 60)
          }
        }), _c('p', {
          class: _vm.$style.circleText,
          style: {
            height: _vm.measureToHeightRatio(270) + 'px',
            'font-size': _vm.height / 4 + 'px'
          }
        }, [_vm._v(_vm._s(props.minutes))]), _c('p', {
          class: _vm.$style.circleLabel,
          style: {
            'margin-top': -(_vm.height / 66.666) + 'px',
            'font-size': _vm.height / 11.111 + 'px'
          }
        }, [_vm._v("MINUTES")])], 1)]) : _vm._e()];
      }
    }], null, false, 1126427851)
  })], 1), _c('img', {
    class: _vm.$style.citySkyline,
    style: {
      left: _vm.measureToHeightRatio(5) + 'px'
    },
    attrs: {
      "src": require("@assets/images/milecountdown/CitySkyline.png"),
      "alt": ""
    }
  }), _c('img', {
    class: _vm.$style.guitarSilhouette,
    attrs: {
      "src": require("@assets/images/milecountdown/GuitarShape.png"),
      "alt": ""
    }
  }), _c('img', {
    class: _vm.$style.guitarAustin,
    style: {
      right: _vm.height / 4 + 'px',
      width: _vm.height / 2.325581395348837 + 'px'
    },
    attrs: {
      "src": require("@assets/images/milecountdown/Guitar.jpg"),
      "alt": ""
    }
  })]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }